const prefix = "app/ReportsV2/WidgetResultByDimension"

export const GET_DIMENSIONS_WATCHER = `${prefix}/GET_DIMENSIONS_WATCHER`
export const GET_DIMENSIONS_SUCCESS = `${prefix}/GET_DIMENSIONS_SUCCESS`
export const GET_DIMENSIONS_FAILED = `${prefix}/GET_DIMENSIONS_FAILED`
